import { deploymentTypes, servers, serverType } from "../deployment-config";
let server_address =
  serverType === deploymentTypes.development
    ? servers.development
    : deploymentTypes.localDevelopment
      ? servers.localDevelopment
      : servers.production;
const PROD_BASE_URL = "https://support.loanlinq.com";
const UAT_BASE_URL = "https://qa-support.loanlinq.com";

const PROD_BASE_URL_NODE = "https://api.loanlinq.com";
const UAT_BASE_URL_NODE = "https://uat-api.loanlinq.com";
// const PROD_BASE_URL_NODE = "http://localhost:8085";

// Function to check if the current environment is UAT
const isUATEnvironment = () => {
  // Check if the current URL contains 'uat'
  return window.location.href.toLowerCase().includes("uat");
};

// Function to get the appropriate base URL based on environment
const getBaseUrl = () => {
  return isUATEnvironment() ? UAT_BASE_URL : PROD_BASE_URL;
  // return UAT_BASE_URL;
};

const getBaseUrlForNodeAPIS = () => {
  return isUATEnvironment() ? UAT_BASE_URL_NODE : PROD_BASE_URL_NODE;
  // return isUATEnvironment() ? PROD_BASE_URL_NODE : PROD_BASE_URL_NODE;
};
// MAKE SURE TO APPEND SLASH AFTER EVERY URL.
// URLs break on safari if there is no trailing slash.
const baseUrlApiTest = `${getBaseUrlForNodeAPIS()}/api/v1/shared`;
const baseUrlApiV1 = `${getBaseUrlForNodeAPIS()}/api/v1`;
const oracleUrl = `${getBaseUrl()}/ords/loanlinq/incident/v1`;
const oracleUrlv2 = `${getBaseUrl()}/ords/loanlinq/incident/v1`;
const oracleUrlWithoutIncidence = `${getBaseUrl()}/ords/loanlinq/v1`;
const oracleUrlWithoutIncidenceNew = `${getBaseUrl()}/ords/loanlinq/v1/dossdoc/get_user`; //new dossdoc page api
const oracleUrlWithoutIncidenceSubmitDoc = `${getBaseUrl()}/ords/loanlinq/v1/dossdoc/get_dossdoc_details`;
const oracleUrlv5 = `${getBaseUrl()}/ords/loanlinq/apex.loanlinq.draw.request.v1`; //new draw request

// const adminUrl = `https://${server_address}/api/v1/admin`;
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dashboard: {
    // getKpis: (lenderId) => `${baseUrlApiTest}/dashboard-kpis/${lenderId}`,
    getKpis: (lenderId, is_broker) =>
      `${baseUrlApiV1}/shared_v2/get_kpi_blocks_data_2/${lenderId}/${is_broker}`,
    getUpcomingpayments: (lenderId) =>
      `${baseUrlApiTest}/upcomingpayments/${lenderId}`,
    getPortfolioOverview: (lenderId, secondParam) =>
      `${baseUrlApiTest}/portfoliooverview/${lenderId}/${secondParam}`,
    getPortfolioOverviewBroker: (lenderId, secondParam) =>
      `${baseUrlApiTest}/portfoliooverviewisbroker/${lenderId}/${secondParam}`,
    getPortfolioOverviewFiltered: (lenderId) =>
      `${baseUrlApiTest}/PortfolioOverview_filtered/${lenderId}`,

    getPortfolioOverviewNew: (lenderId, isBroker) =>
      `${baseUrlApiTest}/PortfolioOverview_filtered_active_internal_loans/${lenderId}/${isBroker}`,
    getPortfolioOverviewBrokerNew: (lenderId, isBroker) =>
      `${baseUrlApiTest}/PortfolioOverview_filtered_active/${lenderId}/${isBroker}`,

    getOldLoanPortfolio: (lenderId, secondParam) =>
      `${baseUrlApiTest}/portfoliooverviewpast/${lenderId}/${secondParam}`,
    getPastPayments: (lenderId) => `${baseUrlApiTest}/pastpayments/${lenderId}`,
    getPastPaymentsloantolender: (loan_id, lenderId) =>
      `${baseUrlApiTest}/pastpayments-loantolender/${loan_id}/${lenderId}`,
    getEventJournal: (lenderId) => `${baseUrlApiTest}/eventjournal/${lenderId}`,
    getLoanAging: (lenderId, is_broker) =>
      `${baseUrlApiTest}/loanaging/${lenderId}/${is_broker}`,
    getInsuranceInfo: (lenderId) =>
      `${baseUrlApiTest}/insuranceInfo/${lenderId}`,
    getInsuranceMonitoring: (lenderId) =>
      `${baseUrlApiTest}/insurance_monitoring_data_list/${lenderId}`,
    getStoreProcedure: (storeEndPoint, lenderId) =>
      `${baseUrlApiTest}/${storeEndPoint}/${lenderId}`,
    getLenderLoans: (lenderId, isBroker) =>
      `${baseUrlApiTest}/lenderloans/${lenderId}/${isBroker}`,
    getLoanTerm1: (lenderRecid, loanRecid) =>
      `${baseUrlApiTest}/QUERY_1_api_v1_get_loan_terms/${lenderRecid}/${loanRecid}`,
    getLoanTerm2: (lenderRecid, loanRecid) =>
      `${baseUrlApiTest}/QUERY_1_api_v1_get_loan_info2/${lenderRecid}/${loanRecid}`,
    getAttachments: (lenderRecid) =>
      `${baseUrlApiTest}/get_attachments/${lenderRecid}`,
    getReactLenderLoans: (lenderId, loan_id) =>
      `${baseUrlApiTest}/react_get_lender_loans/${lenderId}/${loan_id}`,
    getLoanCharges: (loan_id) =>
      `${baseUrlApiTest}/get_loan_charges/${loan_id}`,
    getUserManagement: () => `${baseUrlApiV1}/user_management/manage_users`,
    getDossDocToken: () => `${baseUrlApiV1}/s2sauth/token`,
    getRole: (userId, role) =>
      `${oracleUrlWithoutIncidence}/getrole/${userId}?type=${role}`,
    postRole: () => `${oracleUrlWithoutIncidence}/llq_role`,
    getSingleRole: (userId, roleId) =>
      `${oracleUrlWithoutIncidence}/role_details/${userId}/${roleId}`,
    getLenderOnboard: (userEmail) =>
      `${oracleUrlWithoutIncidence}/lender_onboarding/${userEmail}`,
    postLenderOnboard: () => `${oracleUrlWithoutIncidence}/lender_onboarding`,
    updateLenderOnboard: (jsonId) =>
      `${oracleUrlWithoutIncidence}/update_lender/${jsonId}`,
    getLenderLoanCharges: (lenderRecid) =>
      `${baseUrlApiV1}/lender/loan_charges/${lenderRecid}`,
    getRevYTDPie: (lenderRecid, date) =>
      `${baseUrlApiV1}/lender-info/revenues/${lenderRecid}/${date}`,
    getLoanDistByPriorityPie: (lenderRecid, secondParam) =>
      `${baseUrlApiV1}/lender-info/loan-distribution-by-priority/${lenderRecid}/${secondParam}`,
    getLoanDistByMaturityPie: (lenderRecid, secondParam) =>
      `${baseUrlApiV1}/lender-info/loan-distribution-by-maturity/${lenderRecid}/${secondParam}`,
    getLoanAgingPie: (lenderRecid, secondParam) =>
      `${baseUrlApiV1}/lender-info/loan-aging/${lenderRecid}/${secondParam}`,
    getLoanDistByPropTypePie: (lenderRecid, secondParam) =>
      `${baseUrlApiV1}/lender-info/loan-distribution-by-primary-property-type/${lenderRecid}/${secondParam}`,
    getWLTVByPropTypePie: (lenderRecid, secondParam) =>
      `${baseUrlApiV1}/lender-info/weighted-ltv-by-primary-property-type/${lenderRecid}/${secondParam}`,
    getLoanDistPrinBalPie: (lenderRecid) =>
      `${baseUrlApiV1}/lender-info/lender-info-loan-distribution-prin-bal/${lenderRecid}`,
    billingAttachments: (id) => `${baseUrlApiV1}/billing/attachments/${id}`,
    postLoanLookUp: () => `${baseUrlApiV1}/tools/loan-lookup`,
    postLoanLookUpActive: () => `${baseUrlApiV1}/tools/loan-lookup-active`,
    getMapsKey: `${baseUrlApiV1}/protected/get_maps_key`,
    registerDevice: `${baseUrlApiV1}/trusted-device/register`,
  },
  loanDetails: {
    getReserve: (loanRecid) =>
      `${baseUrlApiV1}/trust-ledger/new-report_Reserve_by_lender_or_loan/${loanRecid}`,
    getImpounds: (loanRecid) =>
      `${baseUrlApiV1}/trust-ledger/new-report_Impound_by_lender_or_loan/${loanRecid}`,
    getMapsKey: `${baseUrlApiV1}/protected/get_maps_key`,
  },
  defaultManagment: {
    getDayPast: (loan_id, isBroker) =>
      `${baseUrlApiV1}/defaultmanagement/31dayspast/${loan_id}/${isBroker}`,
  },
  submitaLoan: {
    getLoanSubmissions: (userID) =>
      `${baseUrlApiV1}/get-loan-submissions/${userID}`,
    postSubmitaLoan: () => `${baseUrlApiV1}/submit-a-loan`,
    getLoanNumber: (lenderId) => `${baseUrlApiTest}/getLoanNumber/${lenderId}`,
    getLoanValues: (lenderId) => `${baseUrlApiTest}/getLoanValues/${lenderId}`,
  },
  reportsNDocuments: {
    getSavedReport: (userID, user_role, type) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedule/get_reports/${userID}/${user_role}/${type}`,
    getScheduledReport: (userID, user_role, type) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedule/get_reports/${userID}/${user_role}/${type}`,
    getScheduledReportDetailsByID: (userID, user_role, type, id) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedule/get_reports/${userID}/${user_role}/${type}?id=${id}`,
    // deleteScheduledReport: (userID, user_role, report_id) =>
    //   `${baseUrlApiV1}/delete-scheduled-report/${userID}/${user_role}/${report_id}`,
    deleteScheduledReport: (id) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedule/delete_schedule/${id}`,
    // deleteSaveReport: (userID, user_role, report_id) =>
    //   `${baseUrlApiV1}/delete-save-report/${userID}/${user_role}/${report_id}`,
    deleteSaveReport: (id) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedule/delete_schedule/${id}`,
    // postSaveReport: () => `${baseUrlApiV1}/save-report`,
    postSaveReport: () =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedule/create_report`,
    postScheduleReport: () =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedule/create_report`,
    postSaveUserPrefrence: () => `${baseUrlApiV1}/user-preferences/save`,
    getUserPrefrence: (userID, user_role) =>
      `${baseUrlApiV1}/user-preferences/fetch/${userID}/${user_role}`,
    deleteUserPrefrence: (userID, user_role, id) =>
      `${baseUrlApiV1}/user-preferences/delete/${userID}/${user_role}/${id}`,
    getReports: (storeEndPoint) => `${baseUrlApiV1}/reports/${storeEndPoint}`,
    // updatedGetReports: () => `${baseUrlApiV1}/reports/all_reports`,
    updatedGetReports: () => `${getBaseUrl()}/ords/loanlinq/orcl/v1/run_report`,
    getReportList: (roleId, userId) =>
      `${getBaseUrl()}/ords/loanlinq/v1/user/reports/${roleId}/${userId}`,
    getReportDetail: (roleId, userId, reportId) =>
      `${getBaseUrl()}/ords/loanlinq/v1/user/reports/v2/${roleId}/${userId}/${reportId}`,
  },
  borrower: {
    getLoanOverview: (loanID) =>
      `${baseUrlApiV1}/borrower/loan-overview/${loanID}`,
    getBorrowerInfo: (loanID) => `${baseUrlApiV1}/borrower/info/${loanID}`,
    getPaymentActivity: (loanID) =>
      `${baseUrlApiV1}/borrower/payment-activity/${loanID}`,
    getLoanFunding: (loanID) => `${baseUrlApiTest}/get_loan_funding/${loanID}`,
    getTrustLedgerReserve: (loanID) =>
      `${baseUrlApiV1}/borrower/trust-ledger-reserve/${loanID}`,
    getAttachments: (loanID) =>
      `${baseUrlApiV1}/borrower/attachments/${loanID}`,
    getAttachmentsUrl: () => `${baseUrlApiV1}/protected/get_tmo_attachments`,
    getPaymentsLoanAchInfo: (loanID) =>
      `${baseUrlApiV1}/loan_ach_info/${loanID}`,
    getPaymentsLoanAchSameDayInfo: (loanID) =>
      `${baseUrlApiV1}/loan_ach_same_day_info/${loanID}`,
    getRoutingNumberValidation: (routingNumber) =>
      `${baseUrlApiV1}/routing_number_validation/${routingNumber}`,
    postPaymentsLoanAchInfo: `${baseUrlApiV1}/loan_ach_info`,
    postPaymentsLoanAchInfoV2: `${baseUrlApiV1}/loan_ach_info_v2`,
    postPaymentsLoanAchInfoUAT: `${getBaseUrl()}/ords/loanlinq/ach/submission_detail`,
    postChequeData: `${baseUrlApiV1}/upload_cheque`,
    postChequeData2: `${baseUrlApiV1}/sameday/upload`,
    getChequeData3: `${getBaseUrl()}/ords/loanlinq/ach/create`,
    postChequeData3: (isOneTimeACH) =>
      isOneTimeACH
        ? `${getBaseUrl()}/ords/loanlinq/ach/onetime_ach`
        : `${getBaseUrl()}/ords/loanlinq/ach/create`,
    postValidateBorrowerEnrollment: `${getBaseUrl()}/ords/loanlinq/v1/validate_borrower_enrollment`,
    updateChequeStatus: `${baseUrlApiV1}/sameday/update`,
    getChequeDataById: (userId) => `${baseUrlApiV1}/sameday/cheques`,
    notes: (loanId) =>
      `${getBaseUrl()}/ords/loanlinq/orcl/v1/loan/notes/${loanId}`,
    // conversationLog: (loanId) =>
    //   `${getBaseUrl()}/ords/loanlinq/orcl/v1/loan/conversation/${loanId}`,
    conversationLog: `${baseUrlApiV1}/protected/LLQ_Get_APPConversationsWithRTFConversion`,
    getNewLoanDetails: (loanId) =>
      `${getBaseUrl()}/ords/loanlinq/v2/loan/${loanId}`,
    getRecentTransactions: (loanId) =>
      `${getBaseUrl()}/ords/loanlinq/v2/loanhistory/${loanId}`,
    getDashboardDetails2: `${baseUrlApiV1}/borrower/get-loan-details`,
    getBorrowerPayoffDetails: (loanId) =>
      `${getBaseUrl()}/ords/loanlinq/demands/demand_payoff_dashboard/${loanId}`,
    getBankingDetails: (user_id, recid) =>
      `${baseUrlApiV1}/borrower/getBankDetails/${user_id}/${recid}`,
    getBankingDetailsForAll: (user_id) =>
      `${getBaseUrl()}/ords/loanlinq/bank_details/v1/post_bank_details/${user_id}`,
    createBankAcccount: `${getBaseUrl()}/ords/loanlinq/bank_details/v1/post_bank_details`,
    deleteBankAccount: (ext_id) =>
      `${baseUrlApiV1}/borrower/delete-bank-account/${ext_id}`,
    getBankAccountDetails: (USR_EXT_ID) =>
      `${getBaseUrl()}/ords/loanlinq/bank_details/v1/get_bank_details/${USR_EXT_ID}`,
    borrowerLoanAging: `${baseUrlApiV1}/borrower/get-loan-aging`,
    borrowerInsuranceExpiry: `${baseUrlApiV1}/borrower/insurance-expiry`,
    borrowerPortfolioLoans: `${baseUrlApiV1}/borrower/portfolio-loans`,
    borrowerDefaultLoans: `${baseUrlApiV1}/borrower/default-loans`,
    borrowerLoansPastDue31Days: `${baseUrlApiV1}/borrower/pastdue-thirtyone-days`,
    borrowerPayoffCalculator: (loanId) =>
      `${getBaseUrl()}/ords/loanlinq/demands/cal_payoff/${loanId}`,
    profileDetails: (userId) =>
      `${getBaseUrl()}/ords/loanlinq/llq_users/get_user_details/${userId}`,
    updateSmsOptIn: `${getBaseUrl()}/ords/loanlinq/llq_users/update_sms_opt`,
    filteredACHData: (ach_status) =>
      `${getBaseUrl()}/ords/loanlinq/borrower/v1/get_ach_details?ach_status=${ach_status}`,
    apiCredentials: (userId) =>
      `${getBaseUrl()}/ords/loanlinq/borrower/v1/get_client_info/${userId}`,
    apiDocumentationLinks: (userId) =>
      `${getBaseUrl()}/ords/loanlinq/v1/dossdoc/get_doc_url?user_id=${userId}`,
    submitTaxInfo: `${baseUrlApiV1}/borrower/submit/tax-info`,
    maturingLoans: `${getBaseUrl()}/ords/loanlinq/borrower/v1/get_mature_loans`,
    insuranceExpiryLoans: `${getBaseUrl()}/ords/loanlinq/borrower/v1/get_insurance_expiration_details`,
    scheduledPayments: (userId) =>
      `${getBaseUrl()}/ords/loanlinq/ach/onetime_ach_details/${userId}`,
    deleteScheduledPayment: (achId) =>
      `${getBaseUrl()}/ords/loanlinq/ach/delete_onetime_ach/${achId}`,
    oneTimePaymentsHistory: (userId) =>
      `${getBaseUrl()}/ords/loanlinq/ach/onetime_ach_payment_history/${userId}`,
    // borrowerAchDetails: `http://localhost:8090/api/v1/borrower/get-ach-details`,
    borrowerTaxInfoOracle: `${getBaseUrl()}/ords/loanlinq/borrower/v1/update_tin`,
    updateStatus: `${getBaseUrl()}/ords/loanlinq/ach/update_ach_status`,
    updateStatusTMO: `${baseUrlApiV1}/borrower/update/loan-status`,
    getAchDetailsSQL: `${baseUrlApiV1}/borrower/get_ach_details_sql`,
    currentDateNTime: `${baseUrlApiV1}/borrower/get_current_date_time`,
    otherDetails: (loanID) =>
      `${baseUrlApiV1}/borrower/get-other-details/${loanID}`,
    nsfNotificationsDashboard: (userId) =>
      `${baseUrlApiTest}/nsf-notifications-dashboard/${userId}`,
    nsfHistoryWithoutDate: (userId) =>
      `${baseUrlApiTest}/nsf-notifications-dashboard-without-date/${userId}`,
    nsfCheckDetails: (userId) =>
      `${getBaseUrl()}/ords/loanlinq/ach/nsf_check_details`,
    nsfPaymentAlertModal: (userId) =>
      `${baseUrlApiTest}/nsf-payment-alert-modal/${userId}`,
    retryPayment: `${getBaseUrl()}/ords/loanlinq/incident/v1/create_nsf_ticket`,
  },
  broker: {
    getActiveLoanSnapShot: (loanID) =>
      `${baseUrlApiV1}/broker/active-loans-snapshot/${loanID}`,
    getActiveOriginatedLoan: (loanID) =>
      `${baseUrlApiV1}/broker/active-originated-loans-no-residual/${loanID}`,
    // getAttachments: (loanID) => `${baseUrlApiV1}/broker/attachments/${loanID}`,
    getAttachments: (loanID) =>
      `${baseUrlApiV1}/shared/get_broker_attachments/${loanID}`,
    getBrokerAttachments: (loanID) =>
      `${baseUrlApiV1}/shared/get_broker_attachments_v2/${loanID}`,
    getAdditionalInterestSkim: (loanID, group) =>
      `${baseUrlApiV1}/broker/lender-additional-interest-skims/${loanID}/${group}`,
  },
  lender: {
    postLenderAchInformation: `${baseUrlApiV1}/lender/insertupdate-tds-lender`,
    getAttachmentsLender: (loanID) =>
      `${baseUrlApiV1}/shared/get_lender_attachments/${loanID}`,
  },
  admin: {
    getAvailableRoles: () => `${baseUrlApiV1}/admin/get-available-roles`,
    getRoleKeys: () => `${baseUrlApiV1}/admin/get-role-keys`,
    postClientKey: () => `${baseUrlApiV1}/admin/add-client-key`,
    postAllUser: (offset) => `${baseUrlApiV1}/admin/all-users/${offset}`,
    postUserByEmail: (email) => `${baseUrlApiV1}/admin/user-by-email/${email}`,
    getUserByID: (userId) =>
      `${oracleUrlWithoutIncidence}/allusers/userid/${userId}`,
    getUser: () => `${baseUrlApiV1}/admin/user-by-email/:email`,
    getRoleOptions: (user_id, role) =>
      `${oracleUrlWithoutIncidence}/llq_user_role_mod_rep/${user_id}?type=${role}`,
    getRoleDetails: (roleId) =>
      `${oracleUrlWithoutIncidence}/role_report_mod_dtl/${roleId}`,
    manageUser: `${oracleUrlWithoutIncidence}/manageuser`,
    validateLoginOTP: `${getBaseUrl()}/ords/loanlinq/v1/authenticate_otp`,
    getUserByEmail: (email) => `${oracleUrlWithoutIncidence}/allusers/${email}`,
    getAuthToken: `${baseUrlApiV1}/auth/get_auth_token`,
    validateLoginOTP: `${getBaseUrl()}/ords/loanlinq/v1/authenticate_otp`,
    getUserByEmailForPartnerFlow: `${getBaseUrl()}/ords/loanlinq/demands/check_user_exist`,
    partnerFlowAuthAPI: `${getBaseUrl()}/ords/loanlinq/demands/authentication`,
    partnerFlowRegisterForTrustedDevice: `${getBaseUrl()}/ords/loanlinq/demands/trusted_devices_register`,
    partnerFlowSession: `${getBaseUrl()}/ords/loanlinq/demands/get_session`,
  },
  tools: {
    getSearchLoans: (query) => `${baseUrlApiV1}/tools/search-loans/${query}`,
    getLookUpLoans: (query) => `${baseUrlApiV1}/tools/lookup-loans/${query}`,
    getActiveSameDayPayments: `${baseUrlApiV1}/tools/active-sameday-payments`,
    postAllUser: (offset) => `${baseUrlApiV1}/admin/all-users/${offset}`,
    getRecentClientUploads: `${baseUrlApiV1}/tools/recent_client_uploads`,
    getApiUsage: `${baseUrlApiV1}/tools/api_usage`,
    postSecureDocumentUploads: `${baseUrlApiV1}/secure_document_uploads`,
    getMaturityOverride: `${baseUrlApiV1}/tools/maturity-override/get-loans`,
    postMaturityOverride: `${baseUrlApiV1}/tools/maturity-override/set-maturity-override`,
    getForeclosureFlag: `${baseUrlApiV1}/tools/get-foreclosure-loans`,
  },
  profile: {
    postChangePassword: `${baseUrlApiV1}/user/reset_password`,
    getLenderAchInformation: (account) =>
      `${baseUrlApiV1}/get-lender/${account}`,
    updateLenderOnboard: `${baseUrlApiV1}/create-lender`,
  },
  customerService: {
    postSearchLoans: () => `${baseUrlApiV1}/csp/all_loans`,
    postSatisfactionFeedback: `${getBaseUrl()}/ords/loanlinq/v1/customer_satisfaction`,
  },
  support: {
    getAllTickets: (user_id) => `${oracleUrl}/report/user_id/${user_id}`,
    getStatusTickets: (user_id, statusType) =>
      `${getBaseUrl()}/ords/loanlinq/incident/v1/report/user_id/${user_id}?status_type=${statusType}`,
    getUpdates: (incidentId) =>
      `${oracleUrl}/report/ticket_id/updates/${incidentId}`,
    getCreateTicketDropdown: (type) => `${oracleUrl}/${type}`,
    getCreateTicketCategories: (type, id) => `${oracleUrl}/${type}/${id}`,
    getSubCategories: (categoryID) =>
      `${oracleUrlv2}/get_subcategory/${categoryID}`,
    getIncidentDetails: (incidentId) =>
      `${oracleUrl}/report/ticket_id/${incidentId}`,
    getAttachments: (incidentId) =>
      `${baseUrlApiV1}/get_support_ticket_attachments/${incidentId}`,
    getSingleAttachment: (name) =>
      `${baseUrlApiV1}/get_support_ticket_attachment/${name}`,
    postTicket: () => `${oracleUrl}/create`,
    postUploadAttachments: `${baseUrlApiV1}/upload_attachments`,
    postUpdate: (incidentId) =>
      `${oracleUrl}/report/ticket_id/updates/${incidentId}`,
    getAttachmentsV2: (incidentId) =>
      `${oracleUrl}/report/ticket_id/attachments/${incidentId}`,
    unsubscribeTicket: `${oracleUrl}/post_unsubscriber_list`,
    uploadAttachment: `${getBaseUrl()}/ords/loanlinq/v1/incident_attachment`,
    createPayoff: `${getBaseUrl()}/ords/loanlinq/demands/Create`,
  },
  msa: {
    getAttachments: (lenderId) =>
      `${baseUrlApiV1}/msa/get_attachments/${lenderId}`,
  },
  forgotPassword: {
    postEmail: `${baseUrlApiV1}/user/get_temp_key`,
    postTempKey: `${baseUrlApiV1}/user/validate_temp_key`,
  },
  manageApiKey: {
    postKeyStatus: `${baseUrlApiV1}/onboarding-apis/fetch`,
    postRegisterApi: `${baseUrlApiV1}/onboarding-apis/register`,
    postUpdateApi: `${baseUrlApiV1}/onboarding-apis/update`,
    recapthca: (value) => `${baseUrlApiV1}/capverify/${value}`,
    recapthcaForVOM: (value) => `${baseUrlApiV1}/capverify-vom/${value}`,
  },
  dosssdoc: {
    getAttachments: (id) =>
      `${oracleUrlWithoutIncidence}/dossdoc/get_attachment/${id}`,
    getDossDocData: (userId) =>
      `${oracleUrlWithoutIncidence}/dossdoc/get_dossdoc/${userId}`,
    getDossDocDataNew: (userId) => `${oracleUrlWithoutIncidenceNew}/${userId}`,
    getDossDocSubmittedDocData: () => `${oracleUrlWithoutIncidenceSubmitDoc}`,
    getDossDocAttachment: `${oracleUrlWithoutIncidence}/dossdoc/dossdoc_attachment`,
    getDossDoc: (id) =>
      `${oracleUrlWithoutIncidence}/dossdoc/get_dossdoc_by_doc/${id}`,
    getMyContribution: (email, payoff_id) =>
      `${getBaseUrl()}/ords/loanlinq/demands/my_contribution/${email}/${payoff_id}`,
  },

  account: {
    addAccount: `${baseUrlApiV1}/accounts/add-account`,
    sendOtp: `${getBaseUrl()}/ords/loanlinq/v1/sendotp`,
    validateOtp: `${getBaseUrl()}/ords/loanlinq/v1/validateotp`,
    addAccountManual: `${getBaseUrl()}/ords/loanlinq/v1/addaccountmanual`,
  },
  newBorrowerLogin: {
    login: `${baseUrlApiV1}/drupal-login`,
    pageContent: `${getBaseUrl()}/ords/f?p=106:2:415924646433442:::::`,
    setPassword: `${getBaseUrl()}/ords/loanlinq/v1/set_password_clear_text`,
  },
  payOffDemand: {
    payOffLoans: (email) =>
      `${getBaseUrl()}/ords/loanlinq/demands/payoff_demand_rpt/${email}`,
    payOffLoansBorrower: (email) =>
      `${getBaseUrl()}/ords/loanlinq/demands/payoff_demand_rpt_borrower/${email}`,
    payOffDetail: (payoffId) =>
      `${getBaseUrl()}/ords/loanlinq/demands/demand_payoff/${payoffId}`,
    updateStatusFlag: () =>
      `${getBaseUrl()}/ords/loanlinq/demands/update_status_flag`,
    previewLetter: (payoff_id) =>
      `${getBaseUrl()}/ords/loanlinq/demands/demand_payoff/${payoff_id}`,
    getMyContributionV2: (email, payoff_id, ownerRecid) =>
      `${getBaseUrl()}/ords/loanlinq/demands/my_contribution/${email}/${payoff_id}/${ownerRecid}`,
     validateOTP: `${baseUrlApiV1}/validate-otp-for-payoff`,
    vaildateEmailOnRoute: (email) => `${baseUrlApiV1}/payoff/${email}`,
    generateTokenForPayoff: `${baseUrlApiV1}/token-for-vom`,
    createThirdPartyPayoff: `${getBaseUrl()}/ords/loanlinq/demands/third_party_auth_create`,
    uploadBorrowerAuth: `${baseUrlApiV1}/upload_borrower_auth_payoff`,
    updateAuthInfo: `${getBaseUrl()}/ords/loanlinq/demands/third_party_add_borrower_auth`,
    checkDuplicatePayoff: `${getBaseUrl()}/ords/loanlinq/demands/third_party_dup_chk`,
    genarateSignaturePdf: `${baseUrlApiV1}/borrower/generate-payoff-signature-pdf`,
    thirdPartyPayoffs: `${getBaseUrl()}/ords/loanlinq/demands/third_party_get_borrower_sign_dtl`,
    uploadSignatureInfo: `${getBaseUrl()}/ords/loanlinq/demands/third_party_sign`,
    authRejection: `${getBaseUrl()}/ords/loanlinq/demands/third_party_reject`,
    validateBorrower: `${getBaseUrl()}/ords/loanlinq/demands/validate_loan_borrower`,
    validateLender: `${getBaseUrl()}/ords/loanlinq/demands/validate_loan_lender`,
    validateExternalBorrower: `${getBaseUrl()}/ords/loanlinq/demands/validate_emailrequest`
  },
  chatbot: {
    askOut: `${PROD_BASE_URL}/ords/loanlinq/v1/chabot`,
  },
  VOM: {
    postSignature: `${getBaseUrl()}/ords/loanlinq/v1/GET_VOM_SIGNATURE`,
    postBorrowerSignature: `${getBaseUrl()}/ords/loanlinq/vom/v1/get_state_name`,
    submitVOM: `${getBaseUrl()}/ords/loanlinq/vom/v1/post_vom_details`,
    fetchVOMRequests: (email) =>
      `${getBaseUrl()}/ords/loanlinq/vom/v1/post_vom_details?email=${email}`,
    fetchBorrowerVOMRequests: `${getBaseUrl()}/ords/loanlinq/vom/v1/get_borrower_loan_dtl`,
    fetchVOMRequestDetails: (requestId) => ``,
    fetchUSStates: `${getBaseUrl()}/ords/loanlinq/vom/v1/get_state_name`,
    validateLoanNumber: (loan_account) =>
      `${getBaseUrl()}/ords/loanlinq/vom/v1/get_property_details?loan_account=${loan_account}`,
    fetchClientSecretForStripe: `${baseUrlApiV1}/create-payment-intent-vom`,
    findPropertyAddress: `${getBaseUrl()}/ords/loanlinq/vom/v1/get_properties`,
    validateBorrowerEmail: `${getBaseUrl()}/ords/loanlinq/vom/v1/validate_borrower`,
    borrowerAuthBucketAPI: `${baseUrlApiV1}/upload_borrower_auth`,
    uploadBorrowerAuth: `${getBaseUrl()}/ords/loanlinq/vom/v1/add_borrower_authorization`,
    VOMInvoiceAPI: `${baseUrlApiV1}/vom-payment-success`,
    validateOTP: `${baseUrlApiV1}/validate-otp-for-vom`,
    vaildateEmailOnRoute: (email) => `${baseUrlApiV1}/vom/${email}`,
    VOMCount: (email) =>
      `${getBaseUrl()}/ords/loanlinq/vom/v1/check_no_of_vom_created/${email}`,
    generateTokenForVOM: `${baseUrlApiV1}/token-for-vom`,
    refundVOMFee: `${baseUrlApiV1}/refund-for-vom`,
    checkDuplicateVOM: `${getBaseUrl()}/ords/loanlinq/vom/v1/check_duplicate`,
  },
  draws: {
    getCurrentDraws: (userId) =>
      `${getBaseUrl()}/ords/loanlinq/apex.loanlinq.draw.request.v1/drawlist/${userId}`,
    getSubmittedDrawDetails: (userId) =>
      `${oracleUrlv5}/draw_request_submitted/${userId}`,
    getDrawProperties: () =>
      `${baseUrlApiV1}/protected/LLQ_get_draw_properties`,
    getLineItems: () => `${oracleUrlv5}/SUBMIT_DRAW_REQUEST`,
    submitDrawRequest: () => `${oracleUrlv5}/SUBMIT_DRAW_REQUEST`,
    getDetailsDrawDashboard: () =>
      `${baseUrlApiV1}/borrower/get-details-draw-dashboard`,
    getDetailsDrawDashboardLoans: () =>
      `${baseUrlApiV1}/borrower/get-details-draw-dashboard-loans`,
  },
  reportsWidget: {
    scheduleReports: (userId, roleType) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedular_report/xxsg-reports/${roleType}/${userId}`,
    downloadReport: (scheduleId) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedular_report/last_7_run/${scheduleId}`,
    pauseReport: (scheduleId) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedular_report/xxsg-reports/${scheduleId}/pause`,
    reRunReport: (scheduleId) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedular_report/xxsg-reports/${scheduleId}/rerun`,
    resumeReport: (scheduleId) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedular_report/xxsg-reports/${scheduleId}/resume`,
    recentCompletedReports: (userId, roleType) =>
      `${getBaseUrl()}/ords/loanlinq/v1/schedular_report/xxsg-reports/${roleType}/${userId}/past_7_days`,
    deleteReport: `${getBaseUrl()}/ords/loanlinq/v1/schedule/delete_schedule`,
  },
};
